//import { set } from 'core-js/core/dict'
import React, { useState } from 'react'
import X from './X.json' 
import axios from 'axios'
require('dotenv').config();

console.log(process.env.NODE_ENV)
const link = "http://34.171.84.131:5000/"

const { GoogleSpreadsheet } = require('google-spreadsheet');
// Initialize the sheet - doc ID is the long id in the sheets URL
const doc = new GoogleSpreadsheet('1-e1YndrEsvlwQ13tUJii35fTR5PillBqZRYIX7JMQek');

// AUTH if NODE_ENV production ie. NEtlify must have .env vars CLIENT_EMAIL PRIVATE KEY values are from gcloud service account creds

(async function() {
    await doc.useServiceAccountAuth({
      // env var values are copied from service account credentials generated by google
      // see "Authentication" section in docs for more info
      client_email:X.client_email,
      private_key:window.atob(X.xxxxxxxxxxxxxxx)
    });
}());




const SizeForm = (props) => {

  const [name, setName] = useState('')
  const [height, setHeight] = useState('')
  const [inseam, setInseam] = useState('')
  const [torsoLength, setTorsoLength] = useState('')
  const [email,setEmail] = useState('')
    

  const nameFieldHandler = (e) => {
    e.preventDefault()
    setName(e.target.value)
  }

  const heightFieldHandler = (e) => {
    e.preventDefault()
    setHeight(e.target.value)
  }

  const inseamFieldHanlder = (e) => {
    e.preventDefault()
    setInseam(e.target.value)
  }

  const torsoLengthFieldHandler = (e) => {
    e.preventDefault()
    setTorsoLength(e.target.value)
  }

  
  const emailFieldHandler = (e) => {
    e.preventDefault();
    setEmail(e.target.value);
  }

  const handleForm = (e) => {
    e.preventDefault()
    
    console.log('form submitted')
    
    const user = {
      name: name,
      email: email,
      height: height,
      inseam: inseam,
      torsoLength: torsoLength,
      metricsFlag: false,
      riderFit: {saddleHeight:'',
        saddleStack:'',
        stackHeight:['',''],
        reach:''
      },
      
      setRiderFit: function(){        
        const saddleHeight = this.inseam *.883 ; 
        const saddleStack = saddleHeight*Math.cos(.296706)
        const stemHeightRange = [Math.floor(.2*this.inseam - 11), Math.floor(.2*this.inseam - 13)]
        const stackHeight = [Math.floor(saddleStack-stemHeightRange[0]-(.15*saddleHeight)),Math.floor(saddleStack-stemHeightRange[1]-(.12*saddleHeight))];              
        const reach = .090909091*(3*this.height+1.5*this.torsoLength-105.5);        
        this.riderFit.saddleHeight = saddleHeight ;
        this.riderFit.saddleStack = saddleStack ;
        if(stackHeight[0] !== 11){
        this.riderFit.stackHeight = stackHeight ;} 
        this.riderFit.reach = [reach,reach+4] ;
        console.log("stemh:"+ stemHeightRange[0]);
      }

    }

    

    user.setRiderFit();

    (async function() {
      await doc.loadInfo(); // loads document properties and worksheets
      console.log(doc.title); // logs doc title for testing purposes
      const sheet = doc.sheetsByIndex[0]; // creates sheet var
      console.log(sheet.title) // logs sheet name for testing
      await sheet.addRow({ Name: user.name, SaddleHeight: user.riderFit.saddleHeight, ReachMin: user.riderFit.reach[0], ReachMax: user.riderFit.reach[1], StackHeight: user.riderFit.stackHeight[0]+1, Height: user.height, Torso: user.torsoLength, Email: user.email }); //modifies sheet with user input
    }());

    axios({
      method: 'post',
      url: link,
      data: {
        Name: user.name,
        SaddleHeight: Math.round(user.riderFit.saddleHeight*10)/10,
        ReachMin: Math.round(user.riderFit.reach[0]*10)/10,
        ReachMax: Math.round(user.riderFit.reach[1]*10)/10,
        StackHeight: Math.round((user.riderFit.stackHeight[0]+1)*10)/10,
        Height: user.height,
        Torso: user.torsoLength,
        Email: user.email

      }
    });

    //const savedInfo = {name: user.name, height: user.height, inseam: user.inseam, torsoLength: user.torsoLength, saddleHeight: user.riderFit.saddleHeight,
      //stackHeightMin: user.riderFit.stackHeight[0], stackHeightMax: user.riderFit.stackHeight//[1], reachMin: user.riderFit.reach[0], reachMax: user.riderFit.reach[1]
    //}

    props.onFormSubmit(user)
    // alert(`${user.name} ${user.height} ${user.inseam} submitted`)
    
    //api post request to save data in a google form
    

    //reset form
    setName('')
    setHeight('')
    setInseam('')
    setTorsoLength('')
    setEmail('')
    
  }


  return (
    <form onSubmit={handleForm} className={`flex flex-col ${props.classes}`}>
      <input type="text" placeholder="Name" value={name} onChange={nameFieldHandler} className="border-2 rounded-md my-2 p-2" />
      <input type="text" placeholder="Email" value={email} onChange={emailFieldHandler} className="border-2 rounded-md my-2 p-2" />
      <input type="text" placeholder="Height (cm)" value={height} onChange={heightFieldHandler} className="border-2 rounded-md my-2 p-2" />
      <input type="text" placeholder="Inseam (cm)" value={inseam} onChange={inseamFieldHanlder} className="border-2 rounded-md my-2 p-2" />
      <input type="text" placeholder="Torso Length (cm)" value={torsoLength} onChange={torsoLengthFieldHandler} className="border-2 rounded-md my-2 p-2" />
      <input type="submit" className="bg-blue-500 text-white p-2 my-2 rounded-md hover:bg-blue-300 hover:text-blue-800" />
    </form>
  )
}

export default SizeForm
